import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  ListOrderSettingsOptions,
  ListOrderSettingsResponse,
  OrderSettings,
  UpdateOrderSettings,
  getOrderSettings as universalGetOrderSettings,
  listOrderSettings as universalListOrderSettings,
  updateOrderSettings as universalUpdateOrderSettings,
} from './restaurants-ordersettings-v3-order-settings-order-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/restaurants' };

/** @internal */
export function getOrderSettings(
  httpClient: HttpClient
): GetOrderSettingsSignature {
  return (orderSettingsId: string) =>
    universalGetOrderSettings(
      orderSettingsId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetOrderSettingsSignature {
  /**
   * Get a OrderSettings by id
   * @param - Id of the OrderSettings to retrieve
   * @returns The retrieved OrderSettings
   */
  (orderSettingsId: string): Promise<
    NonNullablePaths<
      OrderSettings,
      | `approximateAddresses`
      | `policies.privacyPolicy.defaultType`
      | `policies.enabled`
      | `tips.displayType`
      | `tips.suggestedAmounts`
      | `tips.suggestedAmounts.${number}.value`
      | `tips.suggestedAmounts.${number}.default`
      | `tips.suggestedPercentages`
      | `tips.enabled`
      | `availability.periods`
      | `availability.periods.${number}.openDay`
      | `availability.periods.${number}.openTime`
      | `availability.periods.${number}.closeDay`
      | `availability.periods.${number}.closeTime`
      | `availability.specialHourPeriods`
      | `availability.specialHourPeriods.${number}.startDate`
      | `availability.specialHourPeriods.${number}.endDate`
      | `availability.specialHourPeriods.${number}.available`
      | `chargeRoundingStrategy`,
      5
    >
  >;
}

/** @internal */
export function updateOrderSettings(
  httpClient: HttpClient
): UpdateOrderSettingsSignature {
  return (
    _id: string,
    orderSettings: NonNullablePaths<UpdateOrderSettings, `revision`, 2>
  ) =>
    universalUpdateOrderSettings(
      _id,
      orderSettings,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateOrderSettingsSignature {
  /**
   * Update a OrderSettings, supports partial update
   * @param - Order Settings id
   * @returns The updated OrderSettings
   */
  (
    _id: string,
    orderSettings: NonNullablePaths<UpdateOrderSettings, `revision`, 2>
  ): Promise<
    NonNullablePaths<
      OrderSettings,
      | `approximateAddresses`
      | `policies.privacyPolicy.defaultType`
      | `policies.enabled`
      | `tips.displayType`
      | `tips.suggestedAmounts`
      | `tips.suggestedAmounts.${number}.value`
      | `tips.suggestedAmounts.${number}.default`
      | `tips.suggestedPercentages`
      | `tips.enabled`
      | `availability.periods`
      | `availability.periods.${number}.openDay`
      | `availability.periods.${number}.openTime`
      | `availability.periods.${number}.closeDay`
      | `availability.periods.${number}.closeTime`
      | `availability.specialHourPeriods`
      | `availability.specialHourPeriods.${number}.startDate`
      | `availability.specialHourPeriods.${number}.endDate`
      | `availability.specialHourPeriods.${number}.available`
      | `chargeRoundingStrategy`,
      5
    >
  >;
}

/** @internal */
export function listOrderSettings(
  httpClient: HttpClient
): ListOrderSettingsSignature {
  return (options?: ListOrderSettingsOptions) =>
    universalListOrderSettings(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListOrderSettingsSignature {
  /**
   * List Order settings
   */
  (options?: ListOrderSettingsOptions): Promise<
    NonNullablePaths<
      ListOrderSettingsResponse,
      | `orderSettings`
      | `orderSettings.${number}.approximateAddresses`
      | `orderSettings.${number}.policies.privacyPolicy.defaultType`
      | `orderSettings.${number}.policies.enabled`
      | `orderSettings.${number}.tips.displayType`
      | `orderSettings.${number}.tips.enabled`
      | `orderSettings.${number}.chargeRoundingStrategy`,
      6
    >
  >;
}

export {
  ApproximateAddresses,
  Availability,
  ChargeRoundingStrategy,
  DayOfWeek,
  FutureOrdersSettings,
  GetOrderSettingsRequest,
  GetOrderSettingsResponse,
  ListOrderSettingsOptions,
  ListOrderSettingsRequest,
  ListOrderSettingsResponse,
  OrderSettings,
  Policies,
  Policy,
  SpecialHourPeriod,
  TimePeriod,
  TippingRate,
  Tips,
  TipsType,
  Type,
  UpdateOrderSettings,
  UpdateOrderSettingsRequest,
  UpdateOrderSettingsResponse,
} from './restaurants-ordersettings-v3-order-settings-order-settings.universal.js';
